import { FC, Fragment, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useOutletContext } from 'react-router-dom'

import { PageSection } from '@ui/components/PageSection'
import { Tab } from '@ui/components/Tabs'

import { useScrollToTop } from '@hooks/useScrollToTop'

import { useIntroducingBrokerById } from '../hooks/useIntroducingBrokerById'

export const IBRebatesPage: FC = () => {
  useScrollToTop()
  const { t } = useTranslation()
  const { data: introducingBroker, forceRefresh } = useIntroducingBrokerById()

  const tabs: Tab[] = useMemo(
    () => [
      { label: t('IB.RebatesPage.Clients'), path: 'clients' },
      {
        label: t('IB.RebatesPage.Approvals'),
        path: 'approvals',
        alert: !!introducingBroker?.notifications?.hasRebateApprovalsNotification,
      },
      { label: t('IB.RebatesPage.Groups'), path: 'groups' },
      {
        label: t('IB.RebatesPage.Transactions'),
        path: 'transactions',
        alert: !!introducingBroker?.notifications?.hasRebateTransactionsNotification,
      },
    ],
    [
      introducingBroker?.notifications?.hasRebateApprovalsNotification,
      introducingBroker?.notifications?.hasRebateTransactionsNotification,
      t,
    ]
  )

  const refreshIBNotifications = useCallback(() => {
    if (
      introducingBroker?.notifications?.hasRebateApprovalsNotification ||
      introducingBroker?.notifications?.hasRebateTransactionsNotification
    ) {
      forceRefresh(true)
    }
  }, [
    forceRefresh,
    introducingBroker?.notifications?.hasRebateApprovalsNotification,
    introducingBroker?.notifications?.hasRebateTransactionsNotification,
  ])

  return (
    <Fragment>
      <PageSection title={t('IB.RebatesPage.Rebates')} tabData={{ tabs }} />
      <Outlet context={{ refreshIBNotifications }} />
    </Fragment>
  )
}

interface IBRebatesPageOutletContext {
  refreshIBNotifications: () => void
}

export const useIBRebatesPageOutletContext = (): IBRebatesPageOutletContext => {
  return useOutletContext<IBRebatesPageOutletContext>()
}
